import { LocalizedStringsMethods } from 'react-localization';
import LocalizedStrings  from 'react-localization';

interface ISettingsStrings extends LocalizedStringsMethods {
    lsSettingsTxt: string;
    lsUsrNameTxt: string;
    lsUsrAlreadyExistTxt: string;
    lsFNameTxt: string;
    lsLNameTxt: string;
    lsEmailTxt: string;
    lsMobilePhTxt: string;
    lsUsrUpdateSuccessTxt: string;
    lsUpdatePwdTxt: string;
    lsUpdateSettingsTxt: string;
    lsUpdatePwdSuccessTxt: string;
    lsSuccessTxt: string;
    lsOkTxt: string;
    lsOldPassword: string;
    lsNewPassword: string;
    lsConfirmPwd: string;
    lsCancelTxt: string;
    lsPwdMismatchTxt: string;
    lsWrongPwd: string;
    lsSettingsSuccess: string;
    lsForgotPasswordTxt: string;
    lsFindUsernameTxt: string;
    lsResetPwdTx: string;
    lsResetPwdBtnTxt: string;
    lsUsernameTxt: string;
    lsChangePwdTxt: string;
    lsResetPwdTitleTxt: string;
    lsCreateAccountTxt: string;
    lsResetPwdHeadingTxt: string;
    lsResetPwdInputHeadingTxt: string;
    lsEmailAddressTxt: string;
    lsEmailPlaceHolder: string;
    lsPasswordTxt: string;
    lsUsernamePlaceHolderTxt: string;
    lsPwdPlaceHolderTxt: string;
    lsForgotUsernameTitleTxt: string;
    lsForgotPwdTitleTxt: string;
    lsFindUsernameHeadingTxt: string;
    lsForgotPwdHeadingTxt: string;
    lsSuccessPageTitleTxt: string;
    lsReturnToLoginTxt: string;
    lsResetEmailSentTxt: string;
    lsUsernamePlaceholderTxt: string;
    lsCreatePwdHeadingTxt: string;
    lscreatedPwdBtnTxt: string;
    lsExpiredLinkMsg: string;
    lsExpiredAccountMsg: string;
    lsLinkExpr: string;
}

let strings: ISettingsStrings;
export default strings = new LocalizedStrings({
    en: {   
        lsSettingsTxt: 'Settings',
        lsUsrNameTxt: 'Username',
        lsUsrAlreadyExistTxt: 'Username already exists!',
        lsFNameTxt: 'First Name',
        lsLNameTxt: 'Last Name',
        lsEmailTxt: 'Email',
        lsMobilePhTxt: 'Mobile Phone',
        lsUsrUpdateSuccessTxt: 'User updated successfully!',
        lsUpdatePwdTxt: 'Update Password',
        lsFindUsernameTxt: 'Find your username',
        lsResetPwdTx: 'Reset your password ',
        lsUpdateSettingsTxt: 'Update Settings',
        lsUpdatePwdSuccessTxt: 'You successfully updated your password.',
        lsResetEmailSentTxt: 'Password reset email sent!',
        //   + 'Please be sure to update your records to reflect your new password.',
        lsSuccessTxt: 'Success!',
        lsOkTxt: 'Ok',
        lsOldPassword: 'Old Password',
        lsNewPassword: 'New Password',
        lsConfirmPwd: 'Confirm new password',
        lsCancelTxt: 'Cancel',
        lsPwdMismatchTxt: 'Passwords do not match!',
        lsIncorrectEmailTxt: 'This email is not registered',
        lsIncorrectUsernameTxt: 'Incorrect Username',
        lsWrongPwd: 'Old password is incorrect!',
        lsSettingsSuccess: 'Settings updated successfully',
        lsForgotPasswordTxt: 'Forgot Password?',
        lsResetPwdBtnTxt: 'Send password reset email',
        lsUsernameTxt: 'Username',
        lsChangePwdTxt: 'Change password',
        lsResetPwdTitleTxt: 'Change password for {0}. EyeGuide',
        lsCreateAccountTxt: 'Create account for {0}. EyeGuide',
        lsResetPwdHeadingTxt: 'Change password for {0}',
        lsResetPwdInputHeadingTxt: 'Password must contain one lowercase letter, '
        + 'one number, and be at least 7 characters long.',
        lsEmailAddressTxt: 'Email address',
        lsEmailPlaceHolder: 'Enter your email address',
        lsPasswordTxt: 'Password',
        lsUsernamePlaceHolderTxt: 'Enter username',
        lsPwdPlaceHolderTxt: 'Enter new password',
        lsFindUsernameHeadingTxt: 'Enter your email address and '
        + 'we will send you a list of all usernames associated with the email',
        lsForgotPwdHeadingTxt: 'Enter your email address and '
        + 'we will send you a link to reset your password',
        lsForgotUsernameTitleTxt: 'Forgot your username?. EyeGuide',
        lsForgotPwdTitleTxt: 'Forgot your password?. EyeGuide',
        lsSuccessPageTitleTxt: 'Success! · EyeGuide',
        lsReturnToLoginTxt: 'Return to sign in',
        lsUsernamePlaceholderTxt: 'Enter your username',
        lsCreatePwdHeadingTxt: 'Create your password',
        lscreatedPwdBtnTxt: 'Create password',
        lsExpiredLinkMsg: 'Your password reset link has now expired.',
        lsExpiredAccountMsg: 'Your create account link has now expired.',
        lsLinkedUsedMessage: 'Your request cannot be processed. Password Already Updated.',
        lsLinkExpr: 'Link Expired',
        lsLinkUsed: 'Link Already Used'

    },
    es: {
        lsSettingsTxt: 'Settings',
        lsUsrNameTxt: 'Nombre de usuario',
        lsUsrAlreadyExistTxt: 'nombre de usuario ya existe!',
        lsFNameTxt: 'Nombre de pila',
        lsLNameTxt: 'Apellido',
        lsEmailTxt: 'Email',
        lsMobilePhTxt: 'Teléfono móvil',
        lsUsrUpdateSuccessTxt: 'Usuario actualizado con éxito!',
        lsUpdatePwdTxt: 'Update Password',
        lsFindUsernameTxt: 'Find your username',
        lsResetPwdTx: 'Reset your password ',
        lsUpdateSettingsTxt: 'Update Settings',
        lsUpdatePwdSuccessTxt: 'You successfully updated your password.',
        lsResetEmailSentTxt: 'Password reset email sent!',
        // + 'Please be sure to update your records to reflect your new password.',
        lsSuccessTxt: 'éxito!',
        lsOkTxt: 'De acuerdo',
        lsIncorrectEmailTxt: 'This email is not registered',
        lsIncorrectUsernameTxt: 'Incorrect Username',
        lsOldPassword: 'Old Password',
        lsNewPassword: 'New Password',
        lsConfirmPwd: 'Confirm new password',
        lsCancelTxt: 'Cancel',
        lsPwdMismatchTxt: 'Passwords do not match!',
        lsWrongPwd: 'Old password is incorrect!',
        lsSettingsSuccess: 'Settings updated successfully',
        lsForgotPasswordTxt: 'Forgot Password?',
        lsResetPwdBtnTxt: 'Send password reset email',
        lsUsernameTxt: 'Username',
        lsChangePwdTxt: 'Change password',
        lsResetPwdTitleTxt: 'Forgot your password? · EyeGuide',
        lsCreateAccountTxt: 'Create account . EyeGuide',
        lsResetPwdHeadingTxt: 'Reset your password',
        lsResetPwdInputHeadingTxt: 'Password must contain one lowercase letter, '
        + 'one number, and be at least 7 characters long.',
        lsEmailAddressTxt: 'Email address',
        lsEmailPlaceHolder: 'Enter your email address',
        lsPasswordTxt: 'Password',
        lsUsernamePlaceHolderTxt: 'Enter username',
        lsPwdPlaceHolderTxt: 'Enter new password',
        lsForgotUsernameTitleTxt: 'Forgot your username?. EyeGuide',
        lsForgotPwdTitleTxt: 'Forgot your password?. EyeGuide',
        lsFindUsernameHeadingTxt: 'Enter your email address and '
        + 'we will send you a list of all usernames associated with the email',
        lsForgotPwdHeadingTxt: 'Enter your email address and '
        + 'we will send you a link to reset your password',
        lsSuccessPageTitleTxt: 'Success! · EyeGuide',
        lsReturnToLoginTxt: 'Return to sign in',
        lsUsernamePlaceholderTxt: 'Enter your username',
        lsCreatePwdHeadingTxt: 'Create your password',
        lscreatedPwdBtnTxt: 'Create password',
        lsExpiredLinkMsg: 'Your password reset link has now expired.',
        lsExpiredAccountMsg: 'Your create account link has now expired.',
        lsLinkedUsedMessage: 'Your request cannot be processed. Password Already Updated.',
        lsLinkExpr: 'Link Expired',
        lsLinkUsed: 'Link Already Used'
    }
});


// WEBPACK FOOTER //
// ./src/eyeguide-localization/strings.settings.tsx